import "./GenericButton.scss";

type Props = {
  onClick?: () => void;
  label: string;
  theme?: "primary" | "secondary";
  disabled?: boolean;
};

export const GenericButton: React.FC<Props> = ({
  onClick,
  label,
  theme = "primary",
  disabled = false,
}) => {
  return (
    <button
      className={`generic-button ${theme}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
};
